/** Bound the entire SDK/transport/body operation, including implementations that ignore AbortSignal. */
export function purchaseDeadline<T>(operation: (signal: AbortSignal) => Promise<T>, timeoutMs = 12_000, parent?: AbortSignal): Promise<T> {
  return new Promise((resolve, reject) => {
    const controller = new AbortController();
    let settled = false;
    const finish = (error?: unknown, value?: T) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      parent?.removeEventListener('abort', cancel);
      if (error !== undefined) { controller.abort(); reject(error); }
      else resolve(value as T);
    };
    const cancel = () => finish(new Error('PURCHASE_CANCELLED'));
    const timer = setTimeout(() => finish(new Error('PURCHASE_TIMEOUT')), timeoutMs);
    if (parent?.aborted) { cancel(); return; }
    parent?.addEventListener('abort', cancel, { once: true });
    void Promise.resolve().then(() => {
      if (controller.signal.aborted) throw new Error('PURCHASE_CANCELLED');
      return operation(controller.signal);
    }).then((value) => finish(undefined, value), (error: unknown) => finish(error));
  });
}
